export const RAPORSEMTK_GET = 'RAPORSEMTK_GET';
export const RAPORSEMTKDETAIL_GET = 'RAPORSEMTKDETAIL_GET';
export const RAPORSEMTKPDF_GET = 'RAPORSEMTKPDF_GET';